import * as React from "react"
import { Context } from "@contexts/ResponsiveToolCtx.tsx"

const useResponsiveToolCtx = () => React.useContext(Context)

export default useResponsiveToolCtx
